<template>
  <div id="app" class="app" name="app">
    <keep-alive include="Main">
      <router-view/>
    </keep-alive>
  </div>
</template>
<script>
export default {
  // 监听页面刷新：刷新时的from.path为"/"，to.path为当前刷新的页面，路由间跳转时from.path为页面路由
  watch: {
    $route(to, from) {
      // if (from.path === '/') {
      //   if (to.path !== '/chat') {
      // this.$store.commit('user/setStatus', 'busy')
      // }
      // }
    }
  }
}
</script>
